import React from "react";
import "./WhyProblems.css";

const problems = [
  <>You scroll through listings, foreign auctions, and dealer inventory — but that doesn't show you <strong>what the market actually pays.</strong></>,
  <>You waste hours trying to tie together comps, color splits, and accident history — <strong>without ever getting a clean number.</strong></>,
  <>You miss hidden value in rare specs — or <strong>leave money on the table</strong> because you set your reserve too low.</>
];

function WhyProblems() {
  return (
    <div className="why-problems">
      <div className="why-problems__bullets">
        {problems.map((problem, index) => (
          <div className="why-problems__bullet" key={index}>
            <span className="why-problems__bullet-icon">✗</span>
            <p className="why-problems__bullet-text">{problem}</p>
          </div>
        ))}
      </div>
      <div className="why-problems__story">
        <div className="why-problems__story-left">
          <div className="why-problems__story-label">Real Example</div>
          <div className="why-problems__story-amount">$20K</div>
          <p className="why-problems__story-caption">
            lost in a single transaction — <strong>simply because the seller didn't see the right comps.</strong>
          </p>
        </div>
        <div className="why-problems__story-right">
          <p className="why-problems__story-text">
            Matt K. sold his Porsche for $94,000. A week later, a nearly identical car with the same special color and spec sold for $114,000. That's $20,000 left on the table because he was working blind. <strong>Bidder iQ would have shown him the right comps for his car and he could have set his reserve accordingly.</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default WhyProblems;
